module.exports = __webpack_public_path__ + "static/media/irgb.f65e545a.svg";